import React, { useEffect } from 'react';

import SchemaBase from '../../SchemaBase/SchemaBase';

import { useTranslate } from 'react-polyglot';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';


function SchemaSicknessReg(props: SchemaSicknessRegProps) {
    const t = useTranslate();
    const params = useParams();

    const [application, setApplication] = React.useState({
        ownerEmail: "",
        ownerName: "",
        ownerPhone: "",
        dogRegNumber: "",
        dogName: "",
        sickness: [] as string[],
        sicknessOtherText: "",
        otherInfo: ""
    });

    function divider(header?: string, description?: string) {
        return (
            <div className="divider">
                <hr/>
                {header && <h2>{header}</h2>}
                {description && <p>{description}</p>}
            </div>
        );
    }
    
    return (
        <SchemaBase
            title={t('schema.sicknessreg.title')}
            description={t('schema.sicknessreg.description')}
            schema={application}
            schemaKey={"sicknessreg"}
            breedId={params.breedid}
        >
            <div className="sicknessreg">
                {divider(t('schema.sicknessreg.ownertitle'))}
                <div className="inputfield"> {/* Email */}
                    <Form.Label htmlFor="inputOwnerEmail">{t('schema.sicknessreg.owneremail')}</Form.Label>
                    <Form.Control
                        id="inputOwnerEmail"
                        aria-describedby="ownerEmailHelpBlock"
                        value={application.ownerEmail}
                        onChange={(e) => setApplication({...application, ownerEmail: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Name */}
                    <Form.Label htmlFor="inputOwnerName">{t('schema.sicknessreg.ownername')}</Form.Label>
                    <Form.Control
                        id="inputOwnerName"
                        aria-describedby="ownerNameHelpBlock"
                        value={application.ownerName}
                        onChange={(e) => setApplication({...application, ownerName: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Phone */}
                    <Form.Label htmlFor="inputOwnerPhone">{t('schema.sicknessreg.ownerphone')}</Form.Label>
                    <Form.Control
                        id="inputOwnerPhone"
                        aria-describedby="ownerPhoneHelpBlock"
                        value={application.ownerPhone}
                        onChange={(e) => setApplication({...application, ownerPhone: e.target.value})}
                    />
                </div>
                {divider(t('schema.sicknessreg.dogtitle'))}
                <div className="inputfield"> {/* RegNumber */}
                    <Form.Label htmlFor="inputDogRegNumber">{t('schema.sicknessreg.dogregnumber')}</Form.Label>
                    <Form.Control
                        id="inputDogRegNumber"
                        aria-describedby="dogRegNumberHelpBlock"
                        value={application.dogRegNumber}
                        onChange={(e) => setApplication({...application, dogRegNumber: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* Name */}
                    <Form.Label htmlFor="inputDogName">{t('schema.sicknessreg.dogname')}</Form.Label>
                    <Form.Control
                        id="inputDogName"
                        aria-describedby="dogNameHelpBlock"
                        value={application.dogName}
                        onChange={(e) => setApplication({...application, dogName: e.target.value})}
                    />
                </div>
                {divider(t('schema.sicknessreg.sicknesstitle'))}
                <div className="inputfield"> {/* Sickness */}
                    <Form.Label htmlFor="inputSickness">{t('schema.sicknessreg.sickness.title')}</Form.Label>
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessPNP"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.PNP')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("PNP")}
                        onChange={(e) => {
                            if (application.sickness.includes("PNP")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "PNP")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "PNP"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessEpilepsy"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Epilepsy')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Epilepsy")}
                        onChange={(e) => {
                            if (application.sickness.includes("Epilepsy")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Epilepsy")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Epilepsy"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessLungEdema"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.LungEdema')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("LungEdema")}
                        onChange={(e) => {
                            if (application.sickness.includes("LungEdema")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "LungEdema")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "LungEdema"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessDermocysts"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Dermocysts')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Dermocysts")}
                        onChange={(e) => {
                            if (application.sickness.includes("Dermocysts")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Dermocysts")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Dermocysts"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessAllergy"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Allergy')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Allergy")}
                        onChange={(e) => {
                            if (application.sickness.includes("Allergy")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Allergy")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Allergy"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessGlaucoma"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Glaucoma')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Glaucoma")}
                        onChange={(e) => {
                            if (application.sickness.includes("Glaucoma")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Glaucoma")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Glaucoma"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessDwarfism"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Dwarfism')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Dwarfism")}
                        onChange={(e) => {
                            if (application.sickness.includes("Dwarfism")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Dwarfism")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Dwarfism"]});
                            }
                        }}
                    />
                    <Form.Check
                        type={'checkbox'}
                        id="inputSicknessOther"
                        name={"inputSickness"}
                        label={t('schema.sicknessreg.sickness.options.Other')}
                        aria-describedby="sicknessHelpBlock"
                        checked={application.sickness.includes("Other")}
                        onChange={(e) => {
                            if (application.sickness.includes("Other")) {
                                setApplication({...application, sickness: application.sickness.filter((s) => s !== "Other")});
                            } else {
                                setApplication({...application, sickness: [...application.sickness, "Other"]});
                            }
                        }}
                    />
                    <Form.Control
                        id="inputSicknessOtherText"
                        aria-describedby="sicknessOtherTextHelpBlock"
                        value={application.sicknessOtherText}
                        onChange={(e) => setApplication({...application, sicknessOtherText: e.target.value})}
                    />
                </div>
                <div className="inputfield"> {/* OtherInfo */}
                    <Form.Label htmlFor="inputOtherInfo">{t('schema.sicknessreg.otherinfo')}</Form.Label>
                    <Form.Control
                        id="inputOtherInfo"
                        aria-describedby="otherInfoHelpBlock"
                        value={application.otherInfo}
                        onChange={(e) => setApplication({...application, otherInfo: e.target.value})}
                    />
                </div>
            </div>
        </SchemaBase>
    );
}

class SchemaSicknessRegProps {
    
}

export default SchemaSicknessReg;